import { mapGetters } from 'vuex'

export default {
  filters: {
    actableStatus (v) {
      let trim = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]
      let date = new Date()
      let currentTrim = `${date.getFullYear()}${trim.findIndex(x => x.includes(date.getMonth())) + 1}`
      if (!v) {
        return 'NC'
      } else if (currentTrim > v) {
        return 'Oui'
      } else if (currentTrim <= v) {
        return 'Non'
      }
    }
  },
  data () {
    return {
      displayRemuneration: true,
      buttonList: [
        {
          icon: 'fa-file-invoice',
          text: 'Fiche programme',
          action: (id, data) => {
            this.$router.push({ name: 'ProgramVue', params: { id: data.pk } })
          }
        },
        {
          icon: 'fa-edit',
          text: 'Modifier fiche programme',
          display: () => {
            return (this.isAdmin || this.isEditor) && this.isPromoteur
          },
          action: (id, data) => {
            this.$router.push({ name: 'ProgramEdit', params: { id: data.pk } })
          }
        },
        {
          icon: 'fa-folders',
          text: 'Gestions documents',
          display: () => {
            return (this.isAdmin || this.isEditor) && this.isPromoteur
          },
          action: (id, data) => {
            this.$router.push({ name: 'ProgramEdit', params: { id: data.pk }, query: { panel: 'DOCS' } })
          }
        },
        {
          action: (id, data) => {
            if (this.deleteProgram) {
              this.deleteProgram(data)
            } else {
              this.$emit('deleteProgram', data)
            }
          },
          icon: 'fa-trash-alt',
          text: 'Supprimer programme',
          display: () => {
            return this.isAdmin && this.isPromoteur
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur', 'isEditor', 'isDistributeur', 'lastOpenedItemPk'])
  },
  watch: {
    sourcePrograms (v) {
      this.updateSources({ programs: v })
    }
  }
}
